const urlName = '/usercenter/v1'

export default API => ({
    // 客户
    getclientList(pageNum,pageSize,data) {
    return API({
        url: `${urlName}/saas/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
        method:  'get',
        data
    });
},
// 注册
registClient(data) {
    return API({
        url: `${urlName}/saas/save` ,
        method:  'post',
        data
    });
},
// 客户编辑
editClient(data) {
    return API({
        url: `${urlName}/saas/update` ,
        method:  'post',
        data
    });
},
// 管理员
getAdminList(pageNum,pageSize,data) {
    return API({
        url: `${urlName}/administrator/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
        method:  'get',
        data
    });
},
// 注册管理员

registAdmin(data) {
    return API({
        url: `${urlName}/administrator/add?` ,
        method:  'post',
        data
    });
},


patchAdministratorSave({params, data}) {
    return API({
        url: `${urlName}/administrator/save` ,
        method:  'patch',
        params,
        data
    });
},

postAdministratorSave({params, data}) {
    return API({
        url: `${urlName}/administrator/save` ,
        method: 'post',
        params,
        data
    });
},

postAdministratorChangeStatus({params, data}) {
    return API({
        url: `${urlName}/administrator/changeStatus` ,
        method: 'post',
        params,
        data
    });
},

deleteAdministratorSave({params, data}) {
    return API({
        url: `${urlName}/administrator/save` ,
        method: 'delete',
        params,
        data
    });
},

postGenerateAndSetPassword({params, data}) {
    return API({
        url: `${urlName}/account/generateAndSetPassword` ,
        method: 'post',
        params,
        data
    });
},
// 管理状态修改
getAdminStaus(data) {
    console.debug(`${urlName}`);
    return API({
        url: `${urlName}/administrator/update?` ,
        method:  'post',
        data
    });
},

// 重置密码：
resetPwd({ data, params }){
    return API({
        url: `${urlName}/account/resetPassword` ,
        method:  'post',
        data, params
    });
},
// 客户导入

saasDataImport(formData,headers){
    return API({
        url: `${urlName}/saas/saasDataImport` ,
        method:  'post',
        formData,
        headers
    });
},
// 下载模板
downLoadClient(){  //客户
    return API({
        url: `${urlName}/saas/excelTemplateDownLoad` ,
        method:  'get',
    });
},
downLoadUser(headers){ //用户
    return API({
        url: `${urlName}/user/excelTemplateDownLoad` ,
        method:  'get',
        headers
    });
},
/**
  * 获取城市列表
  * 响应数据data：{}
  */
getTree () {
  return API({ url: `/usercenter/v1/region/getTree` });
},

})